import { render } from "./ReserveStepReview.vue?vue&type=template&id=231f6bb9&scoped=true"
import script from "./ReserveStepReview.vue?vue&type=script&lang=js"
export * from "./ReserveStepReview.vue?vue&type=script&lang=js"

import "./ReserveStepReview.vue?vue&type=style&index=0&id=231f6bb9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231f6bb9"]])

export default __exports__